import cn from 'classnames';
import React from 'react';
import checkerTile from './checkerTile.png';

/**
 * A uniform 0.502x of the tile's own 287x310. The tile ships pre-rotated a quarter turn to match
 * the Figma frames. Un-rotate it and no uniform scale fits: it needs 0.46x across and 0.54x down.
 */
const MASK_SIZE = '144px 156px';

const MASK_STYLE: React.CSSProperties = {
  WebkitMaskImage: `url(${checkerTile})`,
  maskImage: `url(${checkerTile})`,
  WebkitMaskRepeat: 'repeat',
  maskRepeat: 'repeat',
  WebkitMaskSize: MASK_SIZE,
  maskSize: MASK_SIZE,
};

interface CheckerBackdropProps {
  /** An svh offset, not a percentage: a page whose content runs past the fold would move the fade. */
  topClassName: string;
}

export const CheckerBackdrop: React.FC<CheckerBackdropProps> = ({ topClassName }) => (
  <>
    <div className={cn('absolute inset-x-0 bottom-0 bg-rice', topClassName)} style={MASK_STYLE} />
    <div className={cn('absolute inset-x-0 h-[25svh] bg-gradient-to-b from-white/90 to-transparent', topClassName)} />
  </>
);
